module.exports = __webpack_public_path__ + "static/media/FiraSansExtraCondensed-Regular.9569b180.ttf";